import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { t } from '@/lib/i18n';

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-[var(--danger)] bg-[var(--surface)] p-8 text-center" role="alert">
      <AlertTriangle className="h-6 w-6 text-[var(--danger)]" aria-hidden="true" />
      <p className="text-sm text-[var(--text)]">{message}</p>
      {onRetry && <Button variant="secondary" size="sm" onClick={onRetry}>{t('common.retry')}</Button>}
    </div>
  );
}
